/* The Alt Art Co - image skeletons, collection sort, live search. */
document.documentElement.classList.add('aac-js');

/* ---- image skeletons: shimmer until each image has actually loaded, then fade it in ---- */
(() => {
  const SEL = '.aac-card__img img, .aac-pdp__main img, .aac-pdp__thumb img, .aac-post__img img, .aac-live__img img';
  const done = (img) => img.closest('.aac-card__img, .aac-pdp__main, .aac-pdp__thumb, .aac-post__img, .aac-live__img')?.classList.add('is-loaded');
  const watch = (img) => {
    if (img.dataset.aacSkel) return; img.dataset.aacSkel = 1;
    if (img.complete && img.naturalWidth) return done(img);
    img.addEventListener('load', () => done(img), { once: true });
    img.addEventListener('error', () => done(img), { once: true });
  };
  const scan = (root) => root.querySelectorAll && root.querySelectorAll(SEL).forEach(watch);
  scan(document);
  new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => n.nodeType === 1 && (n.matches?.(SEL) ? watch(n) : scan(n)))))
    .observe(document.body, { childList: true, subtree: true });
  // product gallery: swapping the main image shows the skeleton again until the new one arrives
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-aac-gallery] [data-full]'); if (!t) return;
    const main = document.querySelector('.aac-pdp__main'), img = main && main.querySelector('img'); if (!img) return;
    main.classList.remove('is-loaded'); delete img.dataset.aacSkel;
    requestAnimationFrame(() => watch(img));
  }, true);
})();

/* ---- collection sort ---- */
(() => {
  const sel = document.querySelector('[data-aac-sort]'); if (!sel) return;
  sel.addEventListener('change', () => {
    const u = new window.URL(location.href);       // not bare URL: inline handlers resolved it to document.URL (a string)
    u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u.toString();
  });
})();
(() => {                                           /* Shop all: expansion picker -> /collections/all/<tag-handle> */
  const sel = document.querySelector('[data-aac-set]'); if (!sel) return;
  sel.addEventListener('change', () => {
    const u = new window.URL(location.href); u.searchParams.delete('page');
    u.pathname = sel.dataset.base + (sel.value ? '/' + sel.value : ''); location.href = u.toString();
  });
})();

/* ---- live search: results as you type (Shopify predictive search), thumbnails + prices ---- */
(() => {
  const form = document.querySelector('[data-aac-live]'); if (!form) return;
  const input = form.querySelector('input[type=search]'), box = form.querySelector('[data-aac-live-results]');
  const money = (v) => '£' + (+v).toFixed(2);
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  let t = 0, seq = 0, act = -1;
  const close = () => { box.hidden = true; act = -1; };
  const render = (q, items) => {
    const all = `${form.action}?type=product&options[prefix]=last&options[fields]=title,tag,product_type&q=${encodeURIComponent(q)}`;
    box.innerHTML = (items.length ? items.map((p) => `<a class="aac-live__row" href="${p.url}">
        <span class="aac-live__img">${p.image ? `<img src="${p.image}${p.image.includes('?') ? '&' : '?'}width=120" alt="" loading="lazy">` : ''}</span>
        <span class="aac-live__txt"><b>${esc(p.title.split(' – ')[0].split(' (')[0])}</b><small>${esc((p.title.match(/\(([^)]+)\)/) || [])[1] || '')}</small></span>
        <span class="aac-live__price">${money(p.price)}</span></a>`).join('')
      : `<div class="aac-live__empty"><b>No sets match "${esc(q)}" yet.</b><span>Try the Pokémon's name, the set or the card number.</span></div>`)
      + `<div class="aac-live__foot">${items.length ? `<a href="${all}">See all results for "${esc(q)}" &rarr;</a>` : ''}<a href="/collections/all?view=pokedex">Browse by Pokémon &rarr;</a></div>`;
    box.hidden = false; act = -1;
  };
  input.addEventListener('input', () => {
    clearTimeout(t); const q = input.value.trim(); if (q.length < 2) return close();
    t = setTimeout(() => {
      const my = ++seq;
      fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,tag,product_type`)
        .then((r) => r.json()).then((j) => { if (my !== seq) return;
          render(q, ((j.resources || {}).results || {}).products || []); }).catch(close);
    }, 180);
  });
  input.addEventListener('keydown', (e) => {
    const rows = [...box.querySelectorAll('.aac-live__row')]; if (box.hidden || !rows.length) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault(); act = (act + (e.key === 'ArrowDown' ? 1 : -1) + rows.length) % rows.length;
      rows.forEach((r, i) => r.classList.toggle('is-act', i === act)); rows[act].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter' && act >= 0) { e.preventDefault(); location.href = rows[act].href; }
    else if (e.key === 'Escape') close();
  });
  document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
  input.addEventListener('focus', () => { if (box.innerHTML && input.value.trim().length >= 2) box.hidden = false; });
})();

/* ---- product page: honest dispatch date (worst case of "1-2 working days", skips weekends + England bank holidays) ---- */
(() => {
  const el = document.querySelector('[data-aac-dispatch]'); if (!el) return;
  const HOL = ['2026-01-01','2026-04-03','2026-04-06','2026-05-04','2026-05-25','2026-08-31','2026-12-25','2026-12-28',
               '2027-01-01','2027-03-26','2027-03-29','2027-05-03','2027-05-31','2027-08-30','2027-12-27','2027-12-28'];
  const now = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/London' }));
  const lastKnown = new Date(HOL[HOL.length - 1]); if (now > lastKnown) return;   // list ran out: keep the generic text
  const work = (d) => d.getDay() % 6 !== 0 && !HOL.includes(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`);
  const d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  for (let n = 0; n < 2;) { d.setDate(d.getDate() + 1); if (work(d)) n++; }
  const when = d.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' });
  el.querySelector('span:last-child').innerHTML = `<b>Order today, dispatched by ${when}.</b> ${el.dataset.ship || 'Free UK tracked delivery'}.`;
})();

/* ---- product page: sticky add-to-basket bar on phones once the main button scrolls away ---- */
(() => {
  const bar = document.querySelector('[data-aac-sticky]'), main = document.querySelector('.aac-pdp__add'); if (!bar || !main) return;
  bar.hidden = false;
  const set = (on) => { bar.classList.toggle('is-on', on); document.body.classList.toggle('aac-has-sticky', on); };
  new IntersectionObserver(([e]) => set(!e.isIntersecting && e.boundingClientRect.top < 0)).observe(main);
  bar.querySelector('[data-aac-sticky-add]').addEventListener('click', () => main.click());
})();
